/**
 * @file   src\services\messagesService.js
 * @brief  This file is responsible for messages services
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import * as endPoints from "../constants/v2/endPoints";
import * as apiService from "./v2/apiService";

export async function updateIntroReplyStatus(introId) {
  return await apiService.apiCall(
    endPoints.UPDATE_INTRO_REPLY_STATUS + `?introductionId=${introId}`,
    "PUT",
  );
}

export async function getIntroMessageDetailsByUserId(requestPayload) {
  return await apiService.apiCall(
    endPoints.GET_INTRODUCTION_MESSAGE_DETAILS +
      `?conversationType=${requestPayload.filter}`,
    "GET",
    {},
  );
}

export async function saveChatEmail(payload) {
  return await apiService.apiCall(endPoints.CHAT_EMAIL, "POST", payload);
}

// DIRECT MESSAGES
export async function getDirectChats(payload) {
  return await apiService.apiCall(
    endPoints.GET_DIRECT_MESSAGES,
    "GET",
    payload,
  );
}

export async function sendDMEmail(payload) {
  return await apiService.apiCall(endPoints.DM_EMAIL, "POST", payload);
}
